// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 14.1172L19.1816 18L16 14.7646L12.8184 18L9 14.1172L16 7L23 14.1172Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.833 9.5L4.5 16.833L1 13.333L8.33301 6L11.833 9.5Z"}}]};

const LogoTencentmeetingFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-tencentmeeting-filled',
    ref,
    icon: element,
  },
));

LogoTencentmeetingFilledIcon.displayName = 'LogoTencentmeetingFilledIcon';

export default LogoTencentmeetingFilledIcon;
